import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createConsumableApi, storeConsumableApi } from './consumableSlice';
import isEmpty from 'lodash/isEmpty';
import { RequestBodyConverter } from '../RequestBodyConverter';
import ConsumableForm from './ConsumableForm';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';

function ConsumableCreate() {
    const [resetCount, setResetCount] = useState(0);
    const { model: initialValues, pictureAttributeNames } = useSelector((state) => state.itemSaga.consumable);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (rawValues) => {
        let values = new RequestBodyConverter(rawValues);
        await values.convertPictures(rawValues, pictureAttributeNames);
        values = values.data;
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.

        dispatch(storeConsumableApi({ navigate, values }));
    };

    useEffect(() => {
        if (isEmpty(initialValues)) {
            dispatch(createConsumableApi());
        }
    }, []);

    return (
        <ConsumableForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default ConsumableCreate;
